module.exports = __webpack_public_path__ + "img/webcalendar.ccc8ddf3.jpg";